// k3s-staging build target (Story 37.21 Task 5) — the in-cluster nginx image
// for the STAGE k3s stack; twin of environment.k3s-development.ts (see that
// file's header for the consolidated single-hostname rationale and why
// admin-ui is the deliberate own-hostname exception).
//
// Same-origin RELATIVE paths for the API surfaces (HttpClient resolves them
// against whatever hostname served the page — k3s-validate.staging today,
// auth.staging after the Task 8 flip, no rebuild); `adminSigninBaseUrl`
// absolute at the admin console's OWN hostname; `authOrigin` runtime-derived
// (the 37.20 code-review rule — never re-derive it from the deliberately
// relative tenantSignupUrl).
export const environment = {
  production: false,
  envLong: 'staging',
  tenantSignupUrl: '/tenant-signup',
  publicTermsUrl: '/terms/active',
  adminSigninBaseUrl: 'https://admin.staging.emjo-consulting.dk/signin',
  // 46.10 code review: was `location.origin`, which was correct only while
  // the brand site was served FROM the auth host at /brand-site. On its own
  // ianua.<env> hostname it started naming the BRAND host, and the only
  // consumer is the public integration docs, which render
  // `{{authBase}}/.well-known/openid-configuration` and `/jwks.json`.
  // Those paths are not routed on ianua, so the brand SPA's catch-all
  // answered 200 text/html — an integrator following the docs got a JSON
  // parse error against a 200, not a 404. Verified live on prod before the
  // fix. This value DOCUMENTS the auth host; it is not used for any fetch
  // (grep: the docs component is the sole reader), so an absolute URL costs
  // nothing in same-origin terms and does not touch CSP connect-src 'self'.
  // The story's "host-independent by construction" note conflated
  // same-origin API calls (still relative, still correct) with naming the
  // auth host (host-dependent).
  authOrigin: 'https://auth.staging.emjo-consulting.dk',
  recaptchaSiteKey: '6Le6s_8sAAAAAOFsqfRcu-bpaidJOUn73Hb0h8_j', //gitleaks:allow -- public reCAPTCHA site key (shipped to browser)
};
